
import { Fragment, useEffect, useState } from "react";
import { Combobox, Dialog, Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../../constants";

const SearchModal = ({ renderTrigger }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState(0);
  const [subcategory, setSubCategory] = useState(0);

  // Artykuły pobierane osobno dla wyszukiwarki
  const [allArticles, setAllArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const navigate = useNavigate();

  // Pobieranie artykułów dopiero po otwarciu wyszukiwarki
  useEffect(() => {
    if (!open || loaded) return;

    setLoading(true);

    fetch(`${BACKEND_URL}/searchArticles`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Błąd pobierania artykułów");
        }
        return res.json();
      })
      .then((result) => {
        setAllArticles(Array.isArray(result) ? result : []);
        setLoaded(true);
      })
      .catch((err) => {
        console.error("Błąd wyszukiwarki:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [open, loaded]);

  const q = query.toLowerCase().trim();

  // Filtrowanie artykułów
  const filteredArticles = allArticles
    .filter((post) => !category || post.category_id == category)
    .filter((post) => !subcategory || post.subcategory_id == subcategory)
    .filter((post) =>
      (post.article_title ?? "").toLowerCase().includes(q)
    )
    .map((post) => ({
      id: post.id,
      label: post.article_title,
      href: `/${(post.name ?? "").toLowerCase()}/${(post.title ?? "").toLowerCase()}/${post.category_id}/${post.subcategory_id}/artykuł/${post.id}`,
    }));

  return (
    <>
      <div onClick={() => setOpen(true)} className="cursor-pointer">
        {renderTrigger ? renderTrigger() : (
          <button className="flex h-10 rounded-full hover:bg-slate-100 justify-center items-center">
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" />
          </button>
        )}
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[99]" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto p-4 md:p-20">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-100"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="mx-auto max-w-2xl rounded-xl shadow-2xl ring-1 ring-black/10 bg-white">

                <Combobox
                  onChange={(item) => {
                    navigate(item.href);
                    setOpen(false);
                  }}
                >

                  <div className="p-4">
                    {/* Kategorie */}
                    <div className="mb-2 flex gap-2">
                      <select
                        value={category}
                        onChange={(e) => setCategory(Number(e.target.value))}
                      >
                        <option value={0}>Wybierz kategorię</option>
                        <option value={1}>Świat</option>
                        <option value={3}>Kraj</option>
                        <option value={5}>Region</option>
                      </select>

                      <select
                        value={subcategory}
                        onChange={(e) => setSubCategory(Number(e.target.value))}
                      >
                        <option value={0}>Wybierz podkategorię</option>
                        <option value={1}>Gospodarka</option>
                        <option value={2}>Polityka</option>
                        <option value={3}>Społeczeństwo</option>
                        <option value={4}>Sport</option>
                      </select>
                    </div>

                    {/* Pole wyszukiwania */}
                    <div className="relative">
                      <MagnifyingGlassIcon className="absolute top-3.5 left-4 h-5 w-5 text-gray-400" />

                     <input
  type="text"
  value={query}
  onChange={(e) => setQuery(e.target.value)}
  onKeyDown={(e) => e.stopPropagation()}
  className="h-12 w-full pl-11 pr-4 text-gray-900 placeholder:text-gray-400"
  placeholder="Szukaj..."
/>
                    </div>
                  </div>

                  {/* Lista wyników */}
                <Combobox.Options
                static
                className="max-h-80 overflow-y-auto bg-white border-t border-gray-200"
              >
                {loading ? (
                  <div className="px-4 py-3 text-sm text-gray-500">
                    Ładowanie artykułów...
                  </div>
                ) : query.trim() === "" ? (
                  <div className="px-4 py-3 text-sm text-gray-500">
                    Wpisz tytuł artykułu, aby wyszukać.
                  </div>
                ) : filteredArticles.length > 0 ? (
                  filteredArticles.map((item) => (
                    <Combobox.Option
                      key={item.id}
                      value={item}
                      className={({ active }) =>
                        `px-4 py-3 cursor-pointer border-b border-gray-100 ${
                          active ? "bg-gray-100" : "bg-white"
                        }`
                      }
                    >
                      {item.label}
                    </Combobox.Option>
                  ))
                ) : (
                  <div className="px-4 py-3 text-sm text-gray-500">
                    Nie znaleziono artykułów.
                  </div>
                )}
              </Combobox.Options>

                </Combobox>

              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default SearchModal;
